import React from "react";
import Layout from "@/components/layout";
import Footer from "@/components/footer";
import OEbook from "@/components/OEbookContent";
import VoceSabia from "@/components/VoceSabia";
import HeaderOne from "@/components/header-one";
import SearchContextProvider from "@/context/search-context";
import MenuContextProvider from "@/context/menu-context";
import HeaderContent from "@/components/HeaderContent";
import FormSection from '../components/formSection'
import SEO from '../components/seo'

const HomeOne = () => {
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout>
          <SEO
            title="O Instagram como aliado da sua escola"
            description="Estratégias de marketing educacional para ampliar resultados e atrair matrículas"
          />
          <HeaderOne />
          <HeaderContent />
          <VoceSabia />
          <OEbook />
          <FormSection/>
          <Footer /> 
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  )
}

export default HomeOne;
